
import { Progress } from "@/components/ui/progress";
import { useTranslation } from "react-i18next";

interface UsageMeterProps {
  title: string;
  used: number;
  limit: number;
  percentage: number;
  resetDate: string;
}

export const UsageMeter = ({
  title,
  used,
  limit,
  percentage,
  resetDate
}: UsageMeterProps) => {
  const { i18n } = useTranslation();
  const isDanish = i18n.language === 'da';
  
  // Format numbers with thousands separator
  const formatNumber = (num: number) => {
    return new Intl.NumberFormat(isDanish ? 'da-DK' : 'en-US').format(num);
  };
  
  // Cap the percentage for display purposes
  const displayPercentage = Math.min(100, Math.max(0, percentage));
  
  // Choose color based on usage percentage
  const getBarColor = () => {
    if (percentage >= 90) return 'text-red-500';
    if (percentage >= 70) return 'text-amber-500';
    return 'text-green-500';
  };
  
  return (
    <div className="space-y-2">
      <div className="text-sm font-medium">{title}</div>
      <div className="flex justify-between text-sm text-gray-500">
        <span>{formatNumber(used)} / {formatNumber(limit)}</span>
        <span className={getBarColor()}>{Math.round(displayPercentage)}%</span>
      </div>
      <Progress 
        value={displayPercentage} 
        className="h-2" 
      />
      {resetDate && (
        <div className="text-xs text-gray-500 mt-1">
          {isDanish ? 'Nulstilles den ' : 'Resets on '}{resetDate}
        </div>
      )}
    </div>
  );
};
